<app-tabs></app-tabs>
<router-outlet></router-outlet>